import { Component, Input } from '@angular/core';

import { PlayerActionsService } from '../../services/player-actions.service';

@Component({
  selector: 'edit-key-operation-mode',
  templateUrl: './edit-key-operation-mode.component.html',
  standalone: false,
})
export class EditKeyOperationModeComponent {
  @Input() model: any = {
    settings: {},
  };

  get keyOperationModeDevice() {
    return (
      this.model?.settings?.keyOperationModeDevice ===
      PlayerActionsService.KEY_OPERATION_MODE_TYPES.BLOCK_ALL
    );
  }

  set keyOperationModeDevice(value: boolean) {
    if (this.model?.settings) {
      this.model.settings.keyOperationModeDevice = value
        ? PlayerActionsService.KEY_OPERATION_MODE_TYPES.BLOCK_ALL
        : PlayerActionsService.KEY_OPERATION_MODE_TYPES.NORMAL;
    }
  }
}
